module.exports = __webpack_public_path__ + "static/media/csharp.bdaccca2.svg";